import { Tooltip as NTooltip, type TooltipProps as Props } from '@heroui/react';

export const Tooltip = (props: Props) => {
  return <NTooltip radius='sm' {...props} />;
};
